import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookies-policy-modal',
  templateUrl: './cookies-policy-modal.component.html',
  styleUrls: ['./cookies-policy-modal.component.scss']
})
export class CookiesPolicyModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
